import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import { getOneCategoryMovie } from '../../graphqlDic';
import { connect } from 'react-redux';
import { TYPE_MOVIES } from '../../constants/TypesAndGenreCategory';
import { LIMIT_ITEMS_MEDIA } from '../../constants/Common';
import CateMoviesComponent from '../../components/MoviePageComponent/CateMoviesComponent';


class CategoryPageMovies extends Component {

    render() {
        let { getOneCategoryMovie } = this.props;
        if (getOneCategoryMovie.loading) return <div className="container"><p className="text-center">Loading...</p></div>;
        if (getOneCategoryMovie.error) return `Error! ${getOneCategoryMovie.error.message}`;
        let dataCategory = getOneCategoryMovie.getOneCategoryMovie;
        return (
            dataCategory ?
            <CateMoviesComponent dataCategory={ dataCategory } />
            : <div className="container"><p className="text-center">Không có nội dung!</p></div>
        );
    }

}

export default compose(
    graphql(getOneCategoryMovie, {
        name: 'getOneCategoryMovie',
        options: (props) => {

            const checkForHexRegExp = new RegExp("^[0-9a-fA-F]{24}$");
            let _id = '';
            if (props.match.params._id && checkForHexRegExp.test(props.match.params._id)) {
                _id = props.match.params._id
            }

            return ({
                variables: {
                    type: TYPE_MOVIES,
                    _id,
                    first: LIMIT_ITEMS_MEDIA,
                    after: '',
                    after_hot: ''
                }
            });
        }
    })
)(connect(
    null,
    null
)(CategoryPageMovies));



// WEBPACK FOOTER //
// ./src/containers/MoviesPage/CategoryPageMovies.js